import { Container } from "@mui/material";
import DisclaimerNl from "@client/mdxFiles/disclaimerNl.mdx";
import DisclaimerFr from "@client/mdxFiles/disclaimerFr.mdx";
import { sizes } from "@styles/Theme";
import { useRouter } from "next/router";

export default function Page() {
  const locale = useRouter().locale;
  return (
    <>
      <Container sx={{ mt: sizes.navBarHeight, height: "100vh" }}>
        {locale == "nl" && <DisclaimerNl />}
        {locale == "fr" && <DisclaimerFr />}
      </Container>
    </>
  );
}
